export const NO_IMAGE_URL = "no-image.svg";
